import { render, staticRenderFns } from "./AssignServices.vue?vue&type=template&id=1553cd37&scoped=true&"
import script from "./AssignServices.vue?vue&type=script&lang=js&"
export * from "./AssignServices.vue?vue&type=script&lang=js&"
import style0 from "./AssignServices.vue?vue&type=style&index=0&id=1553cd37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553cd37",
  null
  
)

export default component.exports